import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { SyllabusQuery, SyllabusService } from '@examdojo/category/v2';
import { SourceService } from '@examdojo/source';
import { catchError, first, map, of, switchMap } from 'rxjs';
import { CmsUrlParts } from '../cms/cms.model';

export const legacySourceRedirectGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const sourceService = inject(SourceService);
  const syllabusService = inject(SyllabusService);
  const syllabusQuery = inject(SyllabusQuery);

  const sourceId: string = route.params['id'];

  if (!sourceId) {
    return router.createUrlTree([`/${CmsUrlParts.Overview}`]);
  }

  return syllabusService.fetchSyllabuses().pipe(
    first(),
    switchMap(() =>
      sourceService.fetch(sourceId).pipe(
        map((source) => source.syllabus_id),
        switchMap((syllabusId) => {
          if (!syllabusId) {
            return of(router.createUrlTree([`/${CmsUrlParts.Overview}`]));
          }

          const syllabus = syllabusQuery.getEntity(syllabusId);

          if (!syllabus) {
            return of(router.createUrlTree([`/${CmsUrlParts.Overview}`]));
          }

          return of(router.createUrlTree([`/${CmsUrlParts.Syllabus}`, syllabus.slug, CmsUrlParts.Sources, sourceId]));
        }),
        catchError(() => of(router.createUrlTree([`/${CmsUrlParts.Overview}`]))),
      ),
    ),
  );
};
